import React, {useContext, useEffect, useState} from "react";
import SelectBox from "../../Componnets/SelectBox";
import GeneralData from "./dataAnalysis/GeneralData";
import Table from "./dataAnalysis/Table";
import appContext from "../../../context/appContext";
import DoughnutChart from "./dataAnalysis/DoughnutChart";
// import BarChart from "./dataAnalysis/BarChart";
import Loading from "../../Componnets/Loading";
import BarChartContainer from "./dataAnalysis/BarChartContainer";
import {createDataPost} from "../../../util/util";
import Export from "../../Componnets/Export/Export";
import ShareFilters from "../../Componnets/ShareFilters/ShareFilters";
import {useFetch} from "../../../hooks/useFetch.hook";
import {useHistory} from "react-router-dom";
import Styles from "../Pages/UserManagement/UserManagment.module.scss";
import ErrorMainPage from "./dataAnalysis/errorMainPage/ErrorMainPage";
import http from "../../../services/api/utilities/http";

const DataAnalysis = (props) => {
    const [data, setData] = useState('')
    const [barChartData, setBarChartData] = useState('')
    const [items, setItems] = useState([])
    const [select, setSelect] = useState('ACTIVITY')
    const [sort, setSort] = useState({})
    const [loading, setLoading] = useState(true)
    const [callSave, setCallSave] = useState(false)
    const [pagination,setPagination] = useState({page:1})
    const [dataAnalysis,setDataAnalysis] = useState(false)
    const [donatChart,setDonatChart] = useState(false)
    const [generalInfo,setGeneralInfo] = useState(false)
    const [error,setError] = useState(false)


    const context = useContext(appContext)
    const saveData = context.handleAutoSave();
    const {
        dataAnalysisVariants,
        dataAnalysisFilters,
        dataAnalysisActiveVariants,
        dataAnalysisFlow,
        dataAnalysisMetrics,
        dataAnalysisAdvancedActivityFilters
    } = saveData

    const history = useHistory()
    let fetchSharedDataUrl
    if (history.location.pathname.includes("share/data_analysis")) {
        const splitPathname = history.location.pathname.split("/")
        fetchSharedDataUrl = `sharing/${splitPathname[splitPathname.length - 1]}`
    }
    const sharedData = useFetch(fetchSharedDataUrl)

    useEffect(() => {
        setSelect(select)
        if (callSave) getData()
    }, [sort,dataAnalysisVariants, dataAnalysisFilters, dataAnalysisActiveVariants, dataAnalysisFlow, dataAnalysisMetrics, callSave, dataAnalysisAdvancedActivityFilters]);

    // useEffect(() => {
    //     if (callSave) getData(1, true);
    // }, [select]);

    const handleSelect = (s) => {
        if (callSave) {
            getData(1, true, s);
        }
    }
    useEffect(() => getSave(context.handleUid().id), [context.handleUid().id])

    useEffect(() => {
        if (!history.location.pathname.includes("share/data_analysis")) {
            return () => setSave()
        }
    }, [data,pagination.page])

    const getSave = (id) => {
       if(!id) {
           return;
       }
        http.get(
            `process_mining/save_data_analysis_state/${id}`
        )
            .then(res => {
                let {
                    dataAnalysisFilters,
                    dataAnalysisVariants,
                    dataAnalysisActiveVariants,
                    dataAnalysisFlow,
                    dataAnalysisMetrics,
                    dataAnalysisAdvancedActivityFilters,
                    column_name,
                    page,
                } = res.data.data.saved_data
                context.handleAutoSave({
                    ...context.handleAutoSave(),
                    dataAnalysisFilters,
                    dataAnalysisVariants,
                    dataAnalysisActiveVariants,
                    dataAnalysisFlow,
                    dataAnalysisMetrics,
                    dataAnalysisAdvancedActivityFilters,
                });
                if(column_name) setSelect(column_name)
                if(page) setPagination({page})
                setCallSave(true)
            }).catch(er => {
            setCallSave(true)
        })
    }

    const setSave = () => {
        if (!data) return
        http.post(
            `process_mining/save_data_analysis_state/${context.handleUid().id}`,
            {
                data_analysis_filters: {
                    dataAnalysisVariants,
                    dataAnalysisActiveVariants,
                    dataAnalysisFilters,
                    dataAnalysisFlow,
                    dataAnalysisMetrics,
                    dataAnalysisAdvancedActivityFilters,
                    column_name: select,
                    page: pagination.page,
                }
            }
        )
            .then(res => {

            })
            .catch(er => console.log(er))
    }

    const getData = (page = pagination.page, changeCol = false , s = select) => {

        context.actionFilter('fetching')
        setLoading(true)
        setError(false)
        let data = createDataPost({
            variants: dataAnalysisVariants,
            active_variants: dataAnalysisActiveVariants,
            filters: dataAnalysisFilters,
            flow: dataAnalysisFlow,
            metrics: dataAnalysisMetrics,
            advanced_activity_filters: dataAnalysisAdvancedActivityFilters,
            page_number: page,
            sort_by:!changeCol && sort.col,
            sort_type: (!changeCol && sort.col) && sort.type,
            // column_name: select.toUpperCase() === 'CASEID' ? 'case' : select,
            column_name: s,
        })



        if(Object.keys(data).length === 0) return

        let id = context.handleUid().id

        if (history.location.pathname.includes("share/data_analysis")) {
            if (sharedData?.data) {
                id = sharedData.data.analysis
                // context.setAnalysisId(id)
                context.handleUid({id})
                const sharedDataFilters = sharedData.data.filters
                if (!context.handleIsFiltersModalOpen()) {
                    data = createDataPost({
                        variants: sharedDataFilters.variants,
                        active_variants: sharedDataFilters.active_variants,
                        filters: sharedDataFilters.filters,
                        flow: sharedDataFilters.flow,
                        metrics: sharedDataFilters.metrics,
                        advanced_activity_filters: sharedDataFilters.advanced_activity_filters,
                        page_number: page,
                        sort_by: !changeCol && sort.col,
                        sort_type: (!changeCol && sort.col) && sort.type,
                        column_name: s,
                    })
                }
            }
        }
        id &&
        http.post(
            `process_mining/data_analysis_filtering/${id}`,
            data
        )
            .then(res => {
                let {start_record,end_record,sort_by ,general_info, donat_chart, sort_type , data_analysis, categorical_columns , page_count, page_number , result_count } = res.data.data
                setData(res.data.data)
                setGeneralInfo(general_info)
                // setDataAnalysis({data_analysis,sort_by,sort_type})
                setDonatChart(donat_chart)
                const pageSize = data_analysis?.length || 0;

                const start = result_count === 0
                    ? 0
                    : (page_number - 1) * pageSize + 1;

                const end = result_count === 0
                    ? 0
                    : start + pageSize - 1;

                setPagination({
                    count: result_count,
                    start,
                    end,
                    next: page_number < page_count,
                    previous: page_number > 1,
                    page: page_number,
                    total_pages: page_count,
                });

                const items = [...(categorical_columns || [])].sort()
                setItems(items)
                if (!history.location.pathname.includes("share/data_analysis")) {
                    if (s) setSelect(s)
                } else if (!context.handleIsFiltersModalOpen()) {
                    const normalizeColumnName = value => String(value || '').toLowerCase()
                    const requestedColumn = items.find(
                        item => normalizeColumnName(item) === normalizeColumnName(s)
                    )
                    const sharedColumn = items.find(
                        item => normalizeColumnName(item) === normalizeColumnName(sharedData?.data?.column_name)
                    )
                    const nextSelect = changeCol
                        ? requestedColumn || s
                        : sharedColumn || requestedColumn || s || items[0]

                    if (nextSelect) setSelect(nextSelect)
                    context.handleAutoSave({
                        ...context.handleAutoSave(),
                        dataAnalysisVariants: data.variants,
                        dataAnalysisActiveVariants: data.active_variants,
                        dataAnalysisFilters: data.filters,
                        dataAnalysisMetrics: data.metrics,
                        dataAnalysisFlow: data.flow,
                        dataAnalysisAdvancedActivityFilters: data.advanced_activity_filters
                    })
                }
                setLoading(false)
                context.actionFilter('success')
            })
            .catch(err => {
                context.actionFilter('error')
                console.error('data_analysis_filtering error:', err?.response?.data || err)
                setError(true)
                setLoading(false)

            })
    }

    useEffect(() => {
        if (sharedData.data) {
            getData()
        }
    }, [sharedData.data])

    try {
        return (
            loading ?
                <Loading/>
                :
                (
                    error ?
                        <ErrorMainPage/> : <div className="row">
                            <div className="col-7">
                                <div className="d-flex justify-content-end">
                                    <div className="d-flex">
                                        {
                                            items.length > 0 &&
                                            <SelectBox selected={select} items={items} setSelect={handleSelect} className="select-box-2"/>
                                        }
                                    </div>
                                    <div className={'d-flex'}>
                                        <div className={'mr-3'}>
                                            {
                                                !history.location.pathname.includes("share/data_analysis") && <ShareFilters selectedColumn={select}/>
                                            }
                                        </div>
                                        <div>
                                            <Export/>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${loading && 'fade-loading'}`}>
                                    {(generalInfo && select) &&
                                        <GeneralData item={select} data={generalInfo}/>
                                    }
                                    <Table sort={sort} select={select} data={data} setSort={setSort}/>
                                    <Pagination pagination={pagination} callPage={getData}/>
                                </div>
                                {/*<CTable  select={select} data={data}/>*/}
                            </div>
                            <div className={`col-5 ${loading && 'fade-loading'}`}>
                                <DoughnutChart loading={loading} data={donatChart} select={select}/>
                                {(data.bar_chart_data && data.bar_chart_data[select]) &&
                                    <BarChartContainer barChartData={data.bar_chart_data} select={select}/>
                                }
                            </div>
                        </div>
                )
        )
    }catch (e){
        return <ErrorMainPage/>
    }
};

export default DataAnalysis;


const Pagination = ({pagination, callPage }) => {



    const [diff , setDiff] = useState(1)
    const maxPage = 12


    const handlePage = (i) => {
        if(i === maxPage + diff){
            setDiff(i => i + 1)
        }else if(i === 1){
            setDiff(1)
        }else if(i < diff){
            setDiff(i => i - 1)
        }
        callPage(i)
    }

    return (
        <div className={Styles.paginationWrapper}>
            <div className={'d-flex'}>
                <div onClick={() => pagination.previous && handlePage(pagination.page - 1)}
                     className={[Styles.btnArrow, pagination.previous ? Styles.active : ''].join(' ')}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.53358 8.16753L13.5002 8.16753" stroke="#C2C7ED" strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"/>
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M7.53369 4.83353L2.24236 8.16753L7.53369 11.5015L7.53369 4.83353Z" stroke="#C2C7ED"
                              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                {diff > 1 &&
                    <>
                        <div onClick={() => handlePage(1)}
                             className={[Styles.btn, pagination.page === pagination.total_pages ? Styles.active : ''].join(' ')}>{1}</div>
                        ...
                        &nbsp;
                    </>
                }

                {[...Array(pagination.total_pages).keys()].map(i => {
                    i = i + diff
                    return (i <= maxPage + diff) && <div onClick={() => handlePage(i,maxPage)} className={[Styles.btn, pagination.page === i ? Styles.active : ''].join(' ')}>{i}</div>
                })}
                {pagination.total_pages > maxPage &&
                    <>
                        ...
                        &nbsp;
                        <div onClick={() => callPage(pagination.total_pages)}
                             className={[Styles.btn, pagination.page === pagination.total_pages ? Styles.active : ''].join(' ')}>{pagination.total_pages}</div>
                    </>
                }
                <div onClick={() => pagination.next && handlePage(pagination.page + 1)}
                     className={[Styles.btnArrow, pagination.next ? Styles.active : ''].join(' ')}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.46642 7.83247H2.49976" stroke="#C2C7ED" strokeWidth="1.5" strokeLinecap="round"
                              strokeLinejoin="round"/>
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M8.46631 11.1665L13.7576 7.83247L8.46631 4.49847V11.1665Z"
                              stroke="#C2C7ED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className={Styles.paginationDescription}>
                Showing <span className="dark-gary-2">{pagination.end - pagination.start + 1}</span> Rows of <span className="dark-gary-2">{pagination.count}</span> Results | <span className="dark-gary-2">{pagination.start} to {pagination.end}</span>
            </div>
        </div>
    )

}
